import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import ConversationListItem from './conversation-list-item.gjs';
import SharedInfinityLoader from 'ember-simplepractice/components/shared/infinity-loader';
import styles from './conversation-list.module.scss';

export default class ConversationList extends Component {
  @service messaging;

  @action
  loadMoreConversations(model) {
    this.messaging.loadMoreConversations.perform(model);
  }

  <template>
    <ul class="{{styles.component}} conversation-list" data-test-conversation-list>
      {{#each @conversations as |conversation|}}
        <ConversationListItem @conversation={{conversation}} />
      {{/each}}

      <SharedInfinityLoader
        @model={{@conversations}}
        @infinityLoad={{this.loadMoreConversations}}
      />
    </ul>
  </template>
}
